// extracted by mini-css-extract-plugin
module.exports = {"accordionHeader":"styles_accordionHeader__14kJ_","accordionContent":"styles_accordionContent__KuPxn","expansionPanel":"styles_expansionPanel__TqjNf"};